<template>
  <div>
    <textarea :id="editorId"></textarea>
  </div>
</template>

<script>
export default {
  name: "CkEditor",
  props: {
    value: String,
    editorId: {
      type: String,
      default: () => `editor-${Math.random().toString(36).substr(2, 9)}`
    },
    config: Object
  },
  data() {
    return {
      editorInstance: null,
    };
  },
  mounted() {
    this.loadEditor();
  },
  beforeDestroy() {
    if (this.editorInstance) {
      this.editorInstance.destroy();
    }
  },
  methods: {
    loadEditor() {
      if (!window.CKEDITOR) {
        const script = document.createElement("script");
        script.src = "/ckeditor/ckeditor.js";
        script.onload = this.initEditor;
        document.head.appendChild(script);
      } else {
        this.initEditor();
      }
    },
    initEditor() {
      this.editorInstance = window.CKEDITOR.replace(this.editorId, {
        ...this.config,versionCheck:false, 
      });
      this.editorInstance.setData(this.value || "");
      this.editorInstance.on("change", () => {
        const data = this.editorInstance.getData();
        this.$emit("input", data);
      });
    }
  }
};
</script>
